var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoClose1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_2",
    "data-name": "Warstwa 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 63 63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-1, .cls-2 {\r\n        stroke-width: 0px;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #003189;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Warstwa_1-2",
    "data-name": "Warstwa 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "gallery_icon_close",
    "data-name": "gallery icon close"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5653",
    "data-name": "Group 5653"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7021-2",
    "data-name": "Path 7021-2",
    className: "cls-1",
    d: "m31.5,63C14.1,63,0,48.9,0,31.5S14.1,0,31.5,0s31.5,14.1,31.5,31.5-14.1,31.5-31.5,31.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6972",
    "data-name": "Path 6972",
    className: "cls-2",
    d: "m24.71,25.86c0,.4.17.78.48,1.04l4.44,4.44c-1.42,1.42-2.14,2.14-4.37,4.37-.08.08-.16.16-.23.24-.35.38-.43.93-.2,1.39.21.51.7.84,1.25.85.4,0,.78-.17,1.04-.48l4.45-4.45h0l1.94-1.94h0l-6.31-6.31c-.08-.08-.16-.16-.24-.23-.38-.35-.94-.43-1.4-.2-.51.21-.84.7-.85,1.25"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7022",
    "data-name": "Path 7022",
    className: "cls-2",
    d: "m38.29,36.83c0-.4-.17-.78-.48-1.04l-4.44-4.44,4.37-4.37c.08-.08.16-.16.23-.24.35-.38.43-.93.2-1.39-.21-.51-.7-.84-1.25-.85-.4,0-.78.17-1.04.48-2.26,2.26-2.99,2.99-4.45,4.45h0l-1.94,1.94h0l6.31,6.31c.08.08.16.16.24.23.38.35.94.43,1.4.2.51-.21.84-.7.85-1.25"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoClose1);
export default __webpack_public_path__ + "static/media/ico-close-1.50ce744ed07ad93ea0257f981d30aecb.svg";
export { ForwardRef as ReactComponent };